// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import muiTheme from "./theme/muiTheme";

import DashboardLayout from "./Layout";
import ParentLogin from "./Pages/Login";
import ParentDashboard from "./Pages/Dashboard";
import Attendance from "./Pages/Attendance";
import Activities from "./Pages/Activities";
import Gallery from "./Pages/Gallery";
import Progress from "./Pages/Progress";
import FeedbackForm from "./Pages/Feedback";
import FeePayments from "./Pages/Fees";
import ParentAnnouncements from "./Pages/Announcements";
import ParentReportCard from "./Pages/ReportCard";
import ParentCalendar from "./Pages/Calendar";
import ParentMessages from "./Pages/Messages";
import ProtectedRoute from "./Pages/protected_route";

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<ParentLogin />} />
          <Route element={<ProtectedRoute />}>
            {/* PARENT LAYOUT WITH NESTED ROUTES */}
            <Route path="/parent" element={<DashboardLayout role="parent" />}>
              <Route index element={<ParentDashboard />} /> {/* default */}
              <Route path="attendance" element={<Attendance />} />
              <Route path="activities" element={<Activities />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="progress" element={<Progress />} />
              <Route path="fees" element={<FeePayments />} />
              <Route path="announcements" element={<ParentAnnouncements />} />
              <Route path="messages" element={<ParentMessages />} />
              <Route path="calendar" element={<ParentCalendar />} />
              <Route path="report-card" element={<ParentReportCard />} />
              <Route path="feedback" element={<FeedbackForm />} />
              <Route path="calendar" element={<ParentCalendar/>}/>
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
